import { render, staticRenderFns } from "./Foot1920.vue?vue&type=template&id=2f68377f&scoped=true"
import script from "./Foot1920.vue?vue&type=script&lang=js"
export * from "./Foot1920.vue?vue&type=script&lang=js"
import style0 from "./Foot1920.vue?vue&type=style&index=0&id=2f68377f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68377f",
  null
  
)

export default component.exports